
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/modal/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<header id='modal_header'>\n  <div id='modal_nav_region'></div>\n</header>\n<form id='modal_panes_region'></form>\n<footer id='modal_footer_region'></footer>\n<div id='modal_spinner_region'></div>\n";
},"useData":true});
    }).call(this);
  